// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
import { Modal, Button, Form, Layout, Card, Table, Image, Media } from 'bootstrap-vue/es/components'
import store from './store'

Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(Modal)
Vue.use(Button)
Vue.use(Form)
Vue.use(Layout)
Vue.use(Card)
Vue.use(Table)
Vue.use(Image)
Vue.use(Media)
Vue.use(Vuex)

Vue.component(
  'Detail',
  require('@/components/Detail').default, {
    props: ['id', 'productId', 'product'],
    created: function () {
      console.log('Detail props', this)
    }
  }
)

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js